import React from "react";
import ISOHeader29990 from "../../../components/ISO Certificates/ISO 29990-2010/ISOHeader29990";
import ISOContent29990 from "../../../components/ISO Certificates/ISO 29990-2010/ISOContent29990";

const ISO299902010 = () => {
  return (
    <div>
      {" "}
      <ISOHeader29990 />
      <ISOContent29990 />
    </div>
  );
};

export default ISO299902010;
